/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import { appConfig } from '../../../../../appConfig';

interface UserProfileState {
    id: string;
    medmeraId?: number;
    isCompany?: boolean;
    isMunicipal?: boolean;
    firstName?: string;
    lastName?: string;
    email: string;
    isAuthenticated: boolean;
    isAuthenticatedWithBankId: boolean;
    hasKimCustomerId: boolean;
    shoppingUserId: string;
    isEpiUser: boolean;
    isShoppingForAnother: boolean;
    isBetaTester: boolean;
}

const getInitialState = () => {
    if (!appConfig.coopUserSettings.isAuthenticated || !appConfig.coopUserSettings.profile) {
        return null;
    }

    const profile: UserProfileState = {
        id: appConfig.coopUserSettings.profile.id,
        medmeraId: appConfig.coopUserSettings.profile.medmeraId,
        isCompany: appConfig.coopUserSettings.profile.isCompany,
        isMunicipal: appConfig.coopUserSettings.profile.isMunicipal,
        firstName: appConfig.coopUserSettings.profile.firstName || undefined,
        lastName: appConfig.coopUserSettings.profile.lastName || undefined,
        email: appConfig.coopUserSettings.profile.email,
        isAuthenticated: appConfig.coopUserSettings.isAuthenticated,
        isAuthenticatedWithBankId: appConfig.coopUserSettings.isAuthenticatedWithBankId,
        hasKimCustomerId: appConfig.coopUserSettings.hasKimCustomerId,
        shoppingUserId: appConfig.coopUserSettings.shoppingUserId,
        isBetaTester: appConfig.coopUserSettings.isBetaTester,
        isShoppingForAnother: appConfig.coopUserSettings.isShoppingForAnother,
        isEpiUser: !!window.epi,
    };

    return profile;
};

const slice = createSlice({
    name: 'userProfile',
    initialState: getInitialState(),
    reducers: {},
});

export const { actions: userProfileActions, reducer: userProfileReducer } = slice;
